import React, { useEffect, useState } from "react";

const Modal = ({ isOpen, onClose, children }) => {
  const [show, setShow] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShow(true);
    } else {
      setTimeout(() => setShow(false), 300); // Delay hiding modal to allow transition
    }
  }, [isOpen]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    {/* Modal container with transition */}
    <div
      className={`bg-white p-4 sm:p-6 rounded modal-scrollbar shadow-lg w-[90%] sm:w-[65%] max-h-[90vh] overflow-hidden relative transition-all transform ${
        isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0"
      }`}
    >
      {/* Modal Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg sm:text-2xl font-semibold text-gray-800">
          Customer Product Details
        </h2>
        <button
          onClick={onClose}
          className="bg-[#1C50A3] text-white w-8 h-8 flex items-center justify-center rounded-full text-xl leading-none focus:outline-none"
        >
          &times;
        </button>
      </div>
  
      <div className="-mx-4 sm:-mx-6">
        <hr className="border-gray-300" />
      </div>
  
      {/* Modal Content */}
      <div className="modal-scrollbar max-h-[calc(90vh-5rem)] overflow-y-auto  ">
        {children}
      </div>
    </div>
  </div>
  
  );
};

export default Modal;
